











































import { Component, Prop, Watch } from 'vue-property-decorator';
import { ProductImageDto } from '@/api';
import Vue from 'vue';
import { Urls } from '@/util/Urls';
import ZoomableImage from '@/views/product/widgets/ZoomableImage.vue';
import { getModule } from 'vuex-module-decorators';
import { ProductDetailStore } from '@/stores/product/product-detail.store';

@Component({
  components: {ZoomableImage},
})
export default class DetailImageGallery extends Vue {
  private detailStore = getModule(ProductDetailStore, this.$store);

  @Prop({required: true})
  public allImages!: ProductImageDto[];

  public zoomModalOpen = false;
  public currentImage: ProductImageDto | null = null;

  public mounted() {
    this.resetCurrentImage();
  }

  /**
   * Images that are interpreted as distinct views. This applies to non-3D images.
   */
  get separateImages(): ProductImageDto[] {
    let images = this.allImages;
    const selectedUnit = this.detailStore.productTuple?.unit;
    if (selectedUnit) {
      const unitImages = this.allImages.filter((image) => image.unitAbbreviation === selectedUnit.abbreviation);
      const remainingImages = this.allImages.filter((image) => image.unitAbbreviation !== selectedUnit.abbreviation);
      images = unitImages.concat(remainingImages);
    }
    return images.filter((img) => !img.is3d);
  }

  /**
   * Images that are grouped together and represent one view together. Used for 3D images.
   */
  get groupedImages(): ProductImageDto[] {
    return this.allImages.filter((img) => img.is3d);
  }

  @Watch('allImages')
  public resetCurrentImage() {
    const selectedUnit = this.detailStore.productTuple?.unit;
    if (this.allImages && this.allImages.length) {
      if (selectedUnit) {
        const unitImage = this.allImages.find((image) => image.unitAbbreviation === selectedUnit.abbreviation);
        if (unitImage) {
          this.currentImage = unitImage;
          return;
        }
      }
      this.currentImage = this.allImages[0];
    } else {
      this.currentImage = null;
    }
  }

  public selectImage(newImage: ProductImageDto): void {
    this.currentImage = newImage;
  }

  public findImagePath(image: ProductImageDto): string {
    return Urls.mediumPathFor(image);
  }

  public selectNextInGroup(): void {
    if (this.currentImage && this.currentImage.is3d) {
      const indexInGroup = this.groupedImages.indexOf(this.currentImage);
      const nextIndexInGroup = (indexInGroup + 1) % this.groupedImages.length;
      this.selectImage(this.groupedImages[nextIndexInGroup]);
    } else {
      const firstInGroup = this.groupedImages[0];
      if (firstInGroup) {
        this.selectImage(firstInGroup);
      }
    }
  }

  public selectPreviousInGroup(): void {
    if (this.currentImage && this.currentImage.is3d) {
      const indexInGroup = this.groupedImages.indexOf(this.currentImage);
      const nextIndexInGroup = (indexInGroup - 1) > -1 ? indexInGroup - 1 : this.groupedImages.length - 1;
      this.selectImage(this.groupedImages[nextIndexInGroup]);
    } else {
      const firstInGroup = this.groupedImages[0];
      if (firstInGroup) {
        this.selectImage(firstInGroup);
      }
    }
  }

  public openZoomModal() {
    this.zoomModalOpen = true;
    this.$nextTick(() => {
      (this.$refs.modal as HTMLElement).focus();
    });
  }

  public closeZoomModal() {
    this.zoomModalOpen = false;
  }

  public onModalFocusOut(event: any) {
    return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      this.closeZoomModal();
    }
  }
}
